export const EMPTY = 'EMPTY';
export const READY = 'READY';
export const LOADING = 'LOADING';
export const ERROR = 'ERROR';



// WEBPACK FOOTER //
// ./app/constants/loadingState.js